module.exports = __webpack_public_path__ + "img/1.cff75df0.jpg";